export default "__VITE_ASSET__WScwmEBK__"